import React, { useState } from 'react';
import AdminSidebar from '../../components/ui/AdminSidebar';
import Icon from '../../components/AppIcon';
import AllPlansTab from './components/AllPlansTab';
import CreatePlanTab from './components/CreatePlanTab';
import PlanFeaturesTab from './components/PlanFeaturesTab';
import PricingRulesTab from './components/PricingRulesTab';

const SubscriptionPricingManagement = () => {
  const [activeTab, setActiveTab] = useState('all-plans');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const tabs = [
    { id: 'all-plans', label: 'All Plans', icon: 'Package' },
    { id: 'create-plan', label: 'Create Plan', icon: 'Plus' },
    { id: 'plan-features', label: 'Plan Features', icon: 'Settings' },
    { id: 'pricing-rules', label: 'Pricing Rules', icon: 'DollarSign' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'all-plans':
        return <AllPlansTab />;
      case 'create-plan':
        return <CreatePlanTab />;
      case 'plan-features':
        return <PlanFeaturesTab />;
      case 'pricing-rules':
        return <PricingRulesTab />;
      default:
        return <AllPlansTab />;
    }
  };

  return (
    <div className="flex min-h-screen bg-background">
      <AdminSidebar isCollapsed={sidebarCollapsed} />
      <div className={`flex-1 transition-smooth ${sidebarCollapsed ? 'lg:ml-20' : 'lg:ml-64'}`}>
        <div className="p-4 md:p-6 lg:p-8">
          {/* Header */}
          <div className="mb-6">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground font-heading flex items-center gap-3">
              <Icon name="CreditCard" size={32} className="text-primary" />
              Subscription & Pricing Management
            </h1>
            <p className="text-sm md:text-base text-muted-foreground font-body mt-2">
              Manage subscription plans, features, and pricing rules
            </p>
          </div>

          {/* Tabs Navigation */}
          <div className="mb-6 border-b border-border overflow-x-auto">
            <div className="flex gap-2 min-w-max">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-2 px-4 py-3 text-sm font-medium transition-smooth border-b-2 whitespace-nowrap ${
                    activeTab === tab?.id
                      ? 'border-primary text-primary bg-primary/5' :'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted'
                  }`}
                >
                  <Icon name={tab?.icon} size={18} />
                  <span className="hidden sm:inline">{tab?.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          <div className="transition-smooth">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPricingManagement;